(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('AdminClusterActionsFunctionsController', AdminClusterActionsFunctionsController);

    function AdminClusterActionsFunctionsController($scope, $state, $stateParams, $translate, config, logger, clusterAction, notifyingService, modalDialogService, dataService) {
        var vm = this;

        var _lazyLoadSkills = _.debounce(loadSkills, 300);

        vm.isAdmin = config.settings.user.isAdmin;
        vm.onlyAssignToFunctions = config.settings.onlyAssignToFunctions;
        vm.item = clusterAction.item;
        
        vm.gridOptions = {
            enableFiltering: true,
            enableSorting: false,
            appScopeProvider: vm,
            onRegisterApi: function (gridApi) {
                vm.gridOptions.gridApi = gridApi;
            },
            columnDefs: [
                {
                    displayName: $translate.instant('department'),
                    name: 'department.name',
                    enableColumnMenu: false,
                    visible: !vm.onlyAssignToFunctions
                },
                {
                    displayName: $translate.instant('function'),
                    name: 'function.roleName',
                    enableColumnMenu: false
                },
                {
                    displayName: $translate.instant('validity'),
                    name: 'validity',
                    cellTemplate: '/app/templates/common/validity-cell.tpl.html',
                    width: 110,
                    minWidth: 110,
                    enableColumnMenu: false,
                    enableFiltering: false,
                    visible: !vm.onlyAssignToFunctions
                },
                {
                    displayName: '',
                    name: 'buttons',
                    cellTemplate: '/app/templates/clusteractions/functions-grid-buttons.tpl.html',
                    width: 100,
                    minWidth: 100,
                    enableColumnMenu: false,
                    enableFiltering: false
                }
            ]
        };

        vm.addFunctions = addFunctions;
        vm.editSkill = editSkill;
        vm.deleteSkill = deleteSkill;
        vm.isCurrentState = isCurrentState;
        vm.loadSkills = loadSkills;

        notifyingService.subscribe($scope, 'skill-updated', function (event, args) {
            if (!vm.selectedSkill || vm.selectedSkill.id !== args.id) return;
            angular.copy(args, vm.selectedSkill);
        });

        notifyingService.subscribe($scope, 'skills-created', function (event, args) {
            var combined = _.union(vm.gridOptions.data, args.data);
            vm.gridOptions.data = _.sortBy(combined, item => {
                return item.department.name != null ? item.department.name.toLowerCase() + item.function.roleName.toLowerCase() : item.function.roleName.toLowerCase();
            });
            vm.gridOptions.gridApi.core.handleWindowResize();
        });

        _initialize();

        function _initialize() {
            loadSkills();
        }

        function addFunctions() {
            if (!vm.onlyAssignToFunctions) {
                $state.go('app-main.admin-clusteractions.functions.add-skill', { id: vm.item.id });
            } else {
                return modalDialogService.openSelectFunctionsDialog().then(functions => {
                    if (!functions) return;
                    return dataService.createSkillsForFunctions(vm.item.id, functions);
                });
            }
        }

        function editSkill(entity) {
            vm.selectedSkill = entity;
            $state.go('app-main.admin-clusteractions.functions.edit-skill', { skillId: entity.id });
        }

        function deleteSkill(entity) {
            return modalDialogService.confirmDelete('delete_skill', 'confirm_delete_skill', () => {
                return dataService.deleteSkill(entity.id)
                    .then(() => {
                        logger.success('successfully_deleted');
                        vm.gridOptions.data.splice(vm.gridOptions.data.indexOf(entity), 1);
                    });
            });
        }

        function isCurrentState() {
            return $state.is('app-main.admin-clusteractions.functions');
        }

        function loadSkills() {
            vm.selectedSkill = null;
            vm.gridOptions.data = [];

            dataService.getSkills(vm.item.id).then(skills => {
                if (skills) {
                    vm.gridOptions.data = skills;
                    vm.gridOptions.gridApi.core.handleWindowResize();
                }
            });
        }
    }
})();